"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const any_1 = require("../any");
/*
 * Return the same array excluding falsey values.
 *
 * @Param {Array} array = An array.
 *
 * @Example
 *
 *     compact(['Pizza', 'Pineapple', null, '', undefined])
 *     //=> ['Pizza', 'Pineapple']
 */
function compact(array) {
    return array.filter(any_1.isPresent);
}
exports.compact = compact;
//# sourceMappingURL=compact.js.map